import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import { FormattedMessage } from 'react-intl';
import { RootPage } from 'modules/rootPage';
import { ErrorPage } from 'modules/common/routes/ErrorPage';
import TIRouteProps from './TIRouteProps';

export const rootRoute: TIRouteProps = {
  path: '/',
  component: RootPage,
  exact: false,
  title: <FormattedMessage id="appTitle" />
};
const tiRoutes: TIRouteProps[] = [rootRoute];

const progress = <LinearProgress />;

export const Routes: React.FC = () => {
  return (
    <Suspense fallback={progress}>
      <Switch>
        <Route path="/network-error" component={ErrorPage} />
        {tiRoutes.map((route: TIRouteProps) => (
          <Route
            key={Array.isArray(route.path) ? route.path[0] : route.path}
            {...route}
          />
        ))}
      </Switch>
    </Suspense>
  );
};
